export enum PhoneVerifyStatusEnum {
  NOT_VERIFIED = 0,
  VERIFIED = 1,
}
